import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { DetailPage } from './detail';
import {DatePipe} from '@angular/common';

@NgModule({
  declarations: [
    DetailPage,
  ],
  imports: [
    IonicPageModule.forChild(DetailPage),
  ],
  exports:[
    DetailPage
  ],
  providers: [
    DatePipe
  ] 
})
export class DetailPageModule {}



// WEBPACK FOOTER //
// ./src/pages/detail/detail.module.ts